import React from "react";

type AnalystItem = {
  company?: string | null;
  industry?: string | null;
  platform?: string | null;
  [key: string]: unknown;
};

type AnalystListProps = {
  items: AnalystItem[];
};

function AnalystList({ items }: AnalystListProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white/90 shadow-sm">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 bg-slate-50">
        <div className="text-sm font-semibold text-slate-900">
          Latest analyst reports
        </div>
        <button className="text-xs rounded-full border border-slate-200 px-3 py-1 hover:bg-white text-slate-600">
          View more
        </button>
      </div>
      <ul className="divide-y divide-slate-100">
        {items.map((it, i) => (
          <li key={i} className="px-4 py-3 flex items-center gap-3">
            <div className="h-9 w-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 text-xs font-bold">
              {(it.company || "?").slice(0, 1)}
            </div>
            <div className="min-w-0">
              <div className="truncate text-sm font-medium text-slate-900">
                {it.company}
              </div>
              <div className="text-xs text-slate-500 truncate">
                {it.industry || it.platform || "—"}
              </div>
            </div>
          </li>
        ))}
        {!items.length && (
          <li className="px-4 py-6 text-center text-slate-500 text-xs">
            No reports yet.
          </li>
        )}
      </ul>
    </div>
  );
}

export { AnalystList };
